<template>
  <BaseVeeForm
    v-if="compose"
    :action="sendMessage"
    v-slot="{ isPending, invalid }"
    class="space-y-2"
  >
    <ValidationProvider name="content" tag="div" vid="content">
      <template #default="{ errors, failed }">
        <BaseFormTextarea rows="3" v-model="formData.content" />
        <BaseFormInlineMessage v-if="failed" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>
    <div class="flex space-x-2">
      <BaseButton success class="w-full" :disabled="invalid || isPending">
        <div class="flex items-center space-x-2 justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 inline-flex"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <line x1="10" y1="14" x2="21" y2="3" />
            <path
              d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
            />
          </svg>
          <span>Send</span>
        </div>
      </BaseButton>
      <BaseButton
        type="button"
        ghost
        class="w-full"
        :disabled="isPending"
        @click="resetComposeFormAndClose"
      >
        Cancel
      </BaseButton>
    </div>
  </BaseVeeForm>
  <div v-else>
    <Dropdown ref="dropdown" placement="bottom-start">
      <template #button="{ open }">
        <BaseButton type="button" primary @click="open"> Send new ... </BaseButton>
      </template>
      <div
        class="origin-top-left mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div class="py-1">
          <MessageSendOption
            v-for="thirdPartyService in thirdPartyServices"
            :key="thirdPartyService.id"
            :third-party-service="thirdPartyService"
            @select="setupNewMessage"
          />
        </div>
      </div>
    </Dropdown>
  </div>
</template>

<script>
import MessageSendOption from './MessageSendOption.vue';

export default {
  components: { MessageSendOption },
  props: {
    conversation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      compose: false,
      formData: {
        thirdPartyServiceId: null,
        content: '',
      },
    };
  },
  computed: {
    thirdPartyServices() {
      return this.$store.getters['ui/accountThirdPartyServices/itemsByParent'](
        this.conversation.accountId
      );
    },
  },
  created() {
    this.fetchThirdPartyServices();
  },
  methods: {
    fetchThirdPartyServices() {
      return this.$store.dispatch('ui/accountThirdPartyServices/load', {
        accountId: this.conversation.accountId,
        params: {
          filter: {
            channel: 'sms,mail',
          },
        },
      });
    },
    setupNewMessage(thirdPartyServiceId) {
      this.formData.thirdPartyServiceId = thirdPartyServiceId;
      this.setCompose(true);
    },
    setCompose(compose) {
      this.compose = Boolean(compose);
    },
    async sendMessage() {
      try {
        await this.$store.dispatch('ui/conversationMessages/store', {
          conversationId: this.conversation.id,
          formData: this.formData,
        });

        this.resetComposeFormAndClose();

        this.$emit('created');

        return Promise.resolve();
      } catch (error) {
        return Promise.rejected(error);
      }
    },
    resetComposeFormAndClose() {
      this.formData.thirdPartyServiceId = null;
      this.formData.content = '';
      this.setCompose(false);
    },
  },
};
</script>
